module.exports = __webpack_public_path__ + "static/media/volca.0b738f8b.png";